import { createContext } from 'react';

import type { HotelsSearchControlsWrapperProps } from 'common-types/types/hotels-components/HotelSearchControlsWrapperProps';

const HotelsPropsContext = createContext<
  HotelsSearchControlsWrapperProps | undefined
>(undefined);

export default HotelsPropsContext;
